﻿import { useQuery, useMutation, useQueryClient } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "lodash";

import { getActiveIngredient, getActiveIngredients, saveActiveIngredient, deleteActiveIngredient } from "@/api/Maintainers/active_ingredients";

const key = "active_ingredients";

export function useActiveIngredient(selected) {
	return useQuery([key, selected], () => selected && getActiveIngredient({ selected }));
}

export function useActiveIngredientsPaginate(params) {
	return useQuery([key, params], () => getActiveIngredients(params));
}

export function useMutateActiveIngredient(params) {
	const navigate = useNavigate();
	const location = useLocation();
	const queryClient = useQueryClient();

	return useMutation(saveActiveIngredient, {
		onSuccess: (response) => {
			const active_ingredients = _.omit(response, "detail");
			const active_ingredient = _.omit(response, key);

			queryClient.setQueryData([key, String(active_ingredient.detail.id)], active_ingredient);
			queryClient.setQueryData([key, params], active_ingredients);

			if (params.search) {
				queryClient.invalidateQueries([key]);
			}

			if (location.state) {
				navigate(location.state);
				return;
			}

			navigate("/mantenedores/ingredientes_activos");
		},
	});
}

export function useMutateDeleteActiveIngredient(params) {
	const queryClient = useQueryClient();

	return useMutation(deleteActiveIngredient, {
		onSuccess: (response) => {
			queryClient.setQueryData([key, params], response);
		},
	});
}
